import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class StripePayoutPermissions {
        constructor(currentUser) {
                const permissionChecker = new PermissionChecker(
                        currentUser,
                );

                this.read = permissionChecker.match(
                        Permissions.values.subpropertyEdit,
                );
                this.StripePayoutAutocomplete = permissionChecker.match(
                        Permissions.values.subpropertyEdit,
                );
                this.create = permissionChecker.match(
                        Permissions.values.subpropertyEdit,
                );
                this.edit = permissionChecker.match(
                        Permissions.values.subpropertyEdit,
                );
        }
}